import React from 'react';
import { SectionHeading } from './SectionHeading';
type PageHeaderProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  children?: React.ReactNode;
};
export function PageHeader({
  eyebrow,
  title,
  description,
  children
}: PageHeaderProps) {
  return <section className="border-b border-petal/70 bg-cream" data-id="element-357" data-mp="1od0h8czg7sb4">
      <div className="mx-auto max-w-7xl px-5 pb-14 pt-14 sm:px-8 sm:pb-16 sm:pt-20" data-id="element-358" data-mp="1jhlb677on0p9">
        <SectionHeading as="h1" eyebrow={eyebrow} title={title} description={description} data-id="element-359" data-mp="2h2zeuwrpkxre" />
        {children ? <div className="mt-8" data-id="element-360" data-mp="2c68ys9fwm25z">{children}</div> : null}
      </div>
    </section>;
}